export default function olsMatrixRegionDefinitionBbox(fields, bounds) {
  const { regionDefinition } = fields;
  return {
    regionDefinition: {
      ...regionDefinition,
      boundingBox: bounds,
    },
  };
}
